exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".confirm-message-container h2{text-align:center}.confirm-logo-container{width:100%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.confirm-logo-container a{display:block;text-align:center}.confirm-logo-container a .logo{width:200px;height:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/routes/confirm.styl
// module id = 490
// module chunks = 0